import { datadogLogs } from '@datadog/browser-logs';

import { getEnvironmentVariables } from 'utility/environment';
import { isServer } from 'utility/isServer';

export const DATADOG_SITE = 'datadoghq.com';
export const DATADOG_SERVICE = 'reservations';

const _warn = console.warn;
const _info = console.info;

export const initializeDatadog = () => {
  if (datadogLogs.getInitConfiguration()) return;

  const {
    BUILD_ID,
    ENABLE_DATADOG,
    ENVIRONMENT_NAME,
    DATADOG_CLIENT_TOKEN = ''
  } = getEnvironmentVariables();

  // Converting to a string so we only have to deal with one type between client and server side
  if (String(ENABLE_DATADOG) !== 'true') {
    return;
  }

  datadogLogs.init({
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE,
    env: ENVIRONMENT_NAME,
    version: BUILD_ID,
    sampleRate: 100
  });

  if (!isServer()) {
    // Override default console.warn functionality and send warning to datadog
    // Usage Format: console.warn('Message', { data: 'object' })
    console.warn = (subject: any, ...args: any[]) => {
      _warn.apply(console, [subject, ...args]);
      const context =
        args.length === 1
          ? args[0]
          : args.length > 1
            ? Object.assign({}, ...args)
            : undefined;
      datadogLogs.logger.warn(subject, context);
    };

    // Override default console.info functionality and send info to datadog
    // Usage Format: console.info('Message', { data: 'object' })
    console.info = (subject: any, ...args: any[]) => {
      _info.apply(console, [subject, ...args]);
      const context =
        args.length === 1
          ? args[0]
          : args.length > 1
            ? Object.assign({}, ...args)
            : undefined;
      datadogLogs.logger.info(subject, context);
    };
  }
};
